import { useState } from 'react';
import Select from 'react-select';
import { SELECT_CATEGORY_OPTIONS } from '../../../global'
import {
    Form,
    SearchInput,
    SearchSubmit,
    SearchIc,
    ClearButton,
    SelectWrap
} from './searchFormElements'
import { useHistory } from 'react-router-dom'

const SearchForm = () => {
    const history = useHistory()
    const [q, setQ] = useState('')
    const [category, setCategory] = useState(null)
    const [selectValue, setSelectValue] = useState(null)

    const handleInputChange = e => setQ(e.target.value)


    const handleClear = () => {
        setQ('')
        setSelectValue(null)
        setCategory(null)
    }

    const handleSubmit = e => {
        e.preventDefault()
        if(!q) return
        history.push({
            pathname: '/search',
            search: `?q=${q}${category ? `&category=${category}`:''}`
        })
    }

    
    const handleCategoryChange = selectedOption => {
        setCategory(selectedOption.value)
        const selected = SELECT_CATEGORY_OPTIONS.find(option => option.value === selectedOption.value)
        setSelectValue(selected)
    }

    return (
        <Form onSubmit={handleSubmit}>
            <SearchInput value={q} onChange={handleInputChange} type="text" placeholder="Nhập từ khóa tìm kiếm" />
            <SelectWrap className='hide-on-mobile'>
                <Select 
                    placeholder='Tìm theo mục'
                    options={SELECT_CATEGORY_OPTIONS}
                    onChange={handleCategoryChange}
                    value={selectValue}

                />
            </SelectWrap>
            <SearchSubmit type="submit"><SearchIc /></SearchSubmit>
            <ClearButton className='hide-on-mobile-tablet' onClick={handleClear} />
        </Form>
    )
}

export default SearchForm
